import React from 'react';
import { useArticleTableOfContents } from 'src/hooks/useArticleTableOfContents';
import { InThisArticleParagraph, TableOfContentStyles } from './TableOfContent.styles';
import useOnMobile from 'src/hooks/useOnMobile';

interface TableOfContentAnchorProps {
  href: string;
  children: React.ReactNode;
}

const TableOfContentAnchor = ({ href, children }: TableOfContentAnchorProps): JSX.Element => {
  const handleAnchorClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    event.preventDefault();
    const element = document.querySelector(href);

    if (!element && typeof window === 'undefined') return;
    window.scrollTo({ top: element.getBoundingClientRect().top + window.pageYOffset - 90, behavior: 'smooth' });
  };

  return <a onClick={handleAnchorClick}>{children}</a>;
};

const TableOfContentContainer = (): JSX.Element => {
  const isMobile = useOnMobile(900);
  const { tocData, hideOnDesktop = false, customizableComponent = null } = useArticleTableOfContents();

  if (!isMobile && hideOnDesktop) return null;

  if (customizableComponent) return customizableComponent();

  return (
    <>
      <InThisArticleParagraph hideOnDesktop={hideOnDesktop}>
        <strong className='ast-strong-element'>
          <span>In this article…</span>
        </strong>
      </InThisArticleParagraph>
      <TableOfContentStyles
        className='table-of-content'
        hideOnDesktop={hideOnDesktop}
      >
        <ul
          style={{ listStyle: 'none' }}
          className='main-list'
        >
          {tocData.map((link, index) => (
            <li
              key={index}
              className='list-item-1'
            >
              <p>
                <TableOfContentAnchor href={`#${link.id}`}>{link.content}</TableOfContentAnchor>
              </p>
              {link.children && (
                <ul
                  style={{ listStyle: 'none' }}
                  className='sub-list'
                >
                  {link.children.map((element, indexChildren) => (
                    <li
                      key={`${index}-${indexChildren}`}
                      className='list-item-2'
                    >
                      <p>
                        <TableOfContentAnchor href={`#${element.id}`}>{element.content}</TableOfContentAnchor>
                      </p>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </TableOfContentStyles>
    </>
  );
};

export default TableOfContentContainer;
